import "../../assets/ft01.css";
import React, { useState, useEffect } from "react";
import FeatherIcon from "feather-icons-react";
import { NavLink, useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";

import { Helmet } from "react-helmet";

const FunnelTemplateTR01 = ({ setPage }) => {
  useEffect(() => {
    setPage("auth");
    currentLanguage(localStorage.getItem("lang") || "EN");
  });
  const [currentLang, currentLanguage] = useState({});

  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  const isExpanded = (index) => expandedFAQ === index;

  return (
    <>
      <Helmet>
        <title>Kepicker</title>
      </Helmet>

      <div id="funnel_template_01" className="page-wrapper">
        <div className="main-layout">
          <div className="main-content">
            <div className="hero-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="hero-layout">
                    <div className="hero-content">
                      <div className="hero-short-title-wrap">
                        <h2 className="hero-short-title">
                          Lorem ipsum dolor sit amet.
                        </h2>
                      </div>
                      <div className="hero-title-wrap">
                        <h1 className="hero-title">
                          ASIN Çek,
                          <br /> Karşılaştır,
                          <br /> Analiz Et ve
                          <br /> Para Kazan!
                        </h1>
                        {/* <div className="hero-title-thumb-wrap">
                          <img
                            src="/assets/img/funnel-images/title-thumb.png"
                            loading="lazy"
                            className="hero-title-thumb"
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="projects-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="projects-layout">
                    <div className="projects">
                      <div className="projects-content">
                        <div className="projects-title-wrap">
                          <div className="projects-title">ASIN Çek.</div>
                        </div>
                        <div className="projects-text-wrap">
                          <p className="projects-text">
                            Rakiplerinizin ASIN’lerini Takip Edemiyor musunuz?
                          </p>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category">
                            <FeatherIcon
                              icon={"alert-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Rakip satıcıların hangi ürünleri sattığını bilmek,
                              stratejinizi şekillendirmek için çok önemli, ancak
                              tüm ASIN'leri tek tek toplamak ve analiz etmek
                              zorlayıcı olabilir.
                            </div>
                          </div>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category tt">
                            <FeatherIcon
                              icon={"check-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Kepicker ile rakiplerinizin sattığı tüm ürünleri
                              sadece saniyeler içinde toplayın, yönetin,
                              düzenleyin, birleştirin.
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="projects-thumb-wrap w-inline-block"
                      >
                        <img
                          src="/assets/img/funnel-images/video-thumb.jpg"
                          loading="lazy"
                          className="projects-thumb"
                        />
                      </a>
                    </div>
                    <div className="projects nn">
                      <a
                        href="#"
                        className="projects-thumb-wrap w-inline-block"
                      >
                        <img
                          src="/assets/img/funnel-images/video-thumb.jpg"
                          loading="lazy"
                          className="projects-thumb"
                        />
                      </a>
                      <div className="projects-content">
                        <div className="projects-title-wrap">
                          <div className="projects-title">
                            ASIN'leri Karşılaştır
                          </div>
                        </div>
                        <div className="projects-text-wrap">
                          <p className="projects-text">
                            Amazon'da En Kârlı Ürünleri Bulmakta Zorlanıyor
                            musunuz?
                          </p>
                        </div>

                        <div className="projects-category-wrap">
                          <div className="projects-category">
                            <FeatherIcon
                              icon={"alert-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Amazon’da rekabet hızla artıyor. Satış yapacak
                              doğru ürünleri bulmak saatler sürebiliyor ve bazen
                              tüm çabanıza rağmen kâr getiren ürünlere
                              ulaşamıyorsunuz.
                            </div>
                          </div>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category tt">
                            <FeatherIcon
                              icon={"check-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Kepicker ile tüm Amazon pazar yerlerinde en kârlı
                              ürünleri hızlıca keşfedin, fiyat
                              karşılaştırmalarını yapın ve rekabette öne geçin!
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="projects">
                      <div className="projects-content">
                        <div className="projects-title-wrap">
                          <div className="projects-title">Analiz Et</div>
                        </div>
                        <div className="projects-text-wrap">
                          <p className="projects-text">
                            Fiyat Karşılaştırmalarını Yaparken Zaman mı
                            Kaybediyorsunuz?
                          </p>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category">
                            <FeatherIcon
                              icon={"alert-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Amazon’da ürünleri araştırmak hem karmaşık hem
                              zaman alıcı olabilir. Tek tek araştırma yapmak ve
                              en doğru stratejiyi oluşturmak için zaman
                              kaybediyorsunuz.
                            </div>
                          </div>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category tt">
                            <FeatherIcon
                              icon={"check-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Fiyatlandırma, metrikler, stok ve diğer önemli tüm
                              ürün analizlerini tek bir ekranda görün,
                              stratejinizi şekillendirin ve onları geçmek için
                              harekete geçin.
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="projects-thumb-wrap w-inline-block"
                      >
                        <img
                          src="/assets/img/funnel-images/video-thumb.jpg"
                          loading="lazy"
                          className="projects-thumb"
                        />
                      </a>
                    </div>
                    <div className="projects nn">
                      <a
                        href="#"
                        className="projects-thumb-wrap w-inline-block"
                      >
                        <img
                          src="/assets/img/funnel-images/video-thumb.jpg"
                          loading="lazy"
                          className="projects-thumb"
                        />
                      </a>
                      <div className="projects-content">
                        <div className="projects-title-wrap">
                          <div className="projects-title">Para Kazan</div>
                        </div>
                        <div className="projects-text-wrap">
                          <p className="projects-text">
                            Amazon’da Satışlarınız Beklediğiniz Gibi Değil Mi?
                          </p>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category">
                            <FeatherIcon
                              icon={"alert-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Amazon’da yanlış fiyatlandırma, fırsatları
                              kaçırmanıza, potansiyel gelirinizi sınırlamanıza
                              ve kârınızı maksimize edememenize neden olabilir.
                            </div>
                          </div>
                        </div>
                        <div className="projects-category-wrap">
                          <div className="projects-category tt">
                            <FeatherIcon
                              icon={"check-circle"}
                              width="20px"
                              height="20px"
                            />
                            <div className="projects-category-text">
                              Kepicker ile ürünlerinizi en doğru fiyatla
                              listeleyin, satış hacminizi artıracak stratejiler
                              geliştirin ve Amazon'da sürekli kazanç elde edin.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <NavLink
                      to="/signup"
                      className="btn-schedule-wrap w-inline-block yy"
                    >
                      <div class="btn-inner">
                        <div>Sen de Şimdi Ürün Keşfine Başla!</div>
                        <div class="btn-schedule-icon w-embed">
                          <FeatherIcon
                            icon={"arrow-right"}
                            width="20px"
                            height="20px"
                          />
                        </div>
                      </div>
                      <div class="btn-schedule-shape"></div>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="section-top-wrap">
                    <div className="section-top-tag">
                      <div>
                        Kullanıcılarımız Kepicker Hakkında Ne Düşünüyor?
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-layout">
                    <div className="testimonial-box">
                      <div className="testimonial-box-brand-thumb">
                        <div className="rating mt--20">
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                        </div>
                      </div>
                      <div className="testimonial-box-text-wrap">
                        <p className="testimonial-box-text">
                          &quot;Arkadaşların eline sağlık. Yazılım oldukça
                          online arbitrajı kolaylaştırıyor ve otomasyon
                          sağlıyor. Her amazon satıcısının sahip olması gereken
                          bir yazılım ve eklenti. Ve sürekli gereken güncelleme
                          ve iyileştirmeler yapılıyor. Hiç bir zaman eklenti
                          veya yazlımın out of date kalmıyor. Tereddüt etmeden
                          abone olun. Ürün bulmak ve analiz etmek ve de
                          kıyaslamak için en iyisi.&quot;
                        </p>
                      </div>
                      <div className="testimonial-box-author-wrap">
                        <div className="testimonial-box-author-info">
                          <h2 className="testimonial-box-author-name">Hakan</h2>
                        </div>
                      </div>
                    </div>
                    <div className="testimonial-box">
                      <div className="testimonial-box-brand-thumb">
                        <div className="rating mt--20">
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                        </div>
                      </div>
                      <div className="testimonial-box-text-wrap">
                        <p className="testimonial-box-text">
                          &quot;çok iyi program. Amazon da arbitrage yapan
                          herkese tavsiye ederim. kullanımı kolay güzel arayüzlü
                          bir eklenti...&quot;
                        </p>
                      </div>
                      <div className="testimonial-box-author-wrap">
                        <div className="testimonial-box-author-info">
                          <h2 className="testimonial-box-author-name">
                            İAS Digital Academy
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="testimonial-box">
                      <div className="testimonial-box-brand-thumb">
                        <div className="rating mt--20">
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                        </div>
                      </div>
                      <div className="testimonial-box-text-wrap">
                        <p className="testimonial-box-text">
                          &quot;Program çok iyi çalışıyor herkese tavsiye ederim
                          gördüğüm en başarılı yazılım ve asla parasına acımadan
                          aldığım hizmet&quot;
                        </p>
                      </div>
                      <div className="testimonial-box-author-wrap">
                        <div className="testimonial-box-author-info">
                          <h2 className="testimonial-box-author-name">
                            Şükrü Can Ezenel
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="testimonial-box">
                      <div className="testimonial-box-brand-thumb">
                        <div className="rating mt--20">
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                          <span>
                            <FeatherIcon icon={"star"} />
                          </span>
                        </div>
                      </div>
                      <div className="testimonial-box-text-wrap">
                        <p className="testimonial-box-text">
                          &quot;Top. Using it for 2 months now and it has been a
                          great help.&quot;
                        </p>
                      </div>
                      <div className="testimonial-box-author-wrap">
                        <div className="testimonial-box-author-info">
                          <h2 className="testimonial-box-author-name">
                            Samet Ağlamaz
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    href="https://chromewebstore.google.com/detail/kepicker/hnpablpopdlabbiopkihkmlfmkgpihdc?hl=en"
                    target="_blank"
                    className="btn-schedule-wrap w-inline-block yy gg"
                  >
                    <div class="btn-inner">
                      <div>Daha Fazlasını Görüntüle</div>
                      <div class="btn-schedule-icon w-embed">
                        <FeatherIcon
                          icon={"arrow-right"}
                          width="20px"
                          height="20px"
                        />
                      </div>
                    </div>
                    <div class="btn-schedule-shape"></div>
                  </a>
                </div>
              </div>
            </div>
            <div className="faq-ft1-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="section-top-wrap">
                    <div className="section-top-tag">
                      <div>Kullanıcılarımızdan Gelen En Sık Sorulanlar</div>
                    </div>
                  </div>
                  <div className="faq-ft1-layout">
                    <div className="faq-ft1-content">
                      {[
                        {
                          question: "Kepicker'ı Ücretsiz Deneyebilir miyim?",
                          answer:
                            "Kesilikle, Kepicker’ı ücretsiz olarak deneyebilir ve sunduğumuz özellikleri keşfedebilirsiniz, süre sınırlaması yerine jeton bazlı deneme paketimiz mevcuttur.",
                        },
                        {
                          question: "Kredi Kartı Gerekli mi?",
                          answer:
                            "Hayır, ücretsiz deneme için kredi kartı bilgisi gerekmez.",
                        },
                        {
                          question: "Marketimi Bağlamak Güvenli mi?",
                          answer:
                            "Kepicker; sizin hesabınızda yer alan verilerinize ya da ürünlerinize kesinlikle erişmez. Ayrıca marketinizi bağlamak hesabınızın askıya alınmasına da kesinlikle sebep olmaz. Kepicker onaylı Amazon yazılımlarından biridir.",
                        },
                        {
                          question: "Neden Marketimi Bağlamam Gerekiyor?",
                          answer:
                            "Kepicker; sizin SP-API'nizi kullanarak tüm verileri direkt Amazon'dan alır, bu da size ürünlerle ilgili en doğru, güncel ve gerçekçi veriyi sağlar.",
                        },
                        {
                          question: "Kepicker'ı Kullanmak Zor mu?",
                          answer:
                            "Bir kere öğrendiniz mi ve çözdünüz mü, sonrasında bırakamayacaksınız!",
                        },
                      ].map((faq, index) => (
                        <div className="faq-ft1" key={index}>
                          <div
                            className="faq-ft1-title-wrap"
                            onClick={() => toggleFAQ(index)}
                          >
                            <h2 className="faq-ft1-title">{faq.question}</h2>
                            <div className="faq-ft1-icon-wrap">
                              <div className="faq-ft1-icon">
                                <div
                                  className="faq-ft1-icon-plus"
                                  style={{
                                    opacity: isExpanded(index) ? 0 : 1,
                                  }}
                                ></div>
                                <div className="faq-ft1-icon-minus"></div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="faq-ft1-text-wrap"
                            style={{
                              height: isExpanded(index) ? "auto" : "0px",
                              overflow: "hidden",
                              transition: "height 0.3s ease",
                            }}
                          >
                            <div className="faq-ft1-text-inner">
                              <p className="faq-ft1-text">{faq.answer}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="services-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="section-top-wrap">
                    <div className="section-top-tag">
                      <div>Dahası Var!</div>
                    </div>
                  </div>
                  <div className="services-layout">
                    <div className="services-box">
                      <div className="services-box-icon-wrap">
                        <img
                          src="/assets/img/funnel-images/service-icon-2.svg"
                          loading="lazy"
                          className="services-box-icon"
                        />
                      </div>
                      <div className="services-box-title-wrap">
                        <h2 className="services-box-title">
                          Consectetur Adipisicing
                        </h2>
                      </div>
                      <div className="services-box-text-wrap">
                        <p className="services-box-text">
                          Esse tenetur veritatis quam assumenda odit
                          perferendis? Natus, dolorum ipsam. Ullam incidunt unde
                          aut?
                        </p>
                      </div>
                    </div>
                    <div className="services-box">
                      <div className="services-box-icon-wrap">
                        <img
                          src="/assets/img/funnel-images/service-icon-2.svg"
                          loading="lazy"
                          className="services-box-icon"
                        />
                      </div>
                      <div className="services-box-title-wrap">
                        <h2 className="services-box-title">
                          Consectetur Adipisicing
                        </h2>
                      </div>
                      <div className="services-box-text-wrap">
                        <p className="services-box-text">
                          Esse tenetur veritatis quam assumenda odit
                          perferendis? Natus, dolorum ipsam. Ullam incidunt unde
                          aut?
                        </p>
                      </div>
                    </div>
                    <div className="services-box">
                      <div className="services-box-icon-wrap">
                        <img
                          src="/assets/img/funnel-images/service-icon-2.svg"
                          loading="lazy"
                          className="services-box-icon"
                        />
                      </div>
                      <div className="services-box-title-wrap">
                        <h2 className="services-box-title">
                          Consectetur Adipisicing
                        </h2>
                      </div>
                      <div className="services-box-text-wrap">
                        <p className="services-box-text">
                          Esse tenetur veritatis quam assumenda odit
                          perferendis? Natus, dolorum ipsam. Ullam incidunt unde
                          aut?
                        </p>
                      </div>
                    </div>
                    <div className="services-box">
                      <div className="services-box-icon-wrap">
                        <img
                          src="/assets/img/funnel-images/service-icon-2.svg"
                          loading="lazy"
                          className="services-box-icon"
                        />
                      </div>
                      <div className="services-box-title-wrap">
                        <h2 className="services-box-title">
                          Consectetur Adipisicing
                        </h2>
                      </div>
                      <div className="services-box-text-wrap">
                        <p className="services-box-text">
                          Esse tenetur veritatis quam assumenda odit
                          perferendis? Natus, dolorum ipsam. Ullam incidunt unde
                          aut?
                        </p>
                      </div>
                    </div>
                  </div>
                  <NavLink
                    to="/signup"
                    className="btn-schedule-wrap w-inline-block yy gg ff"
                  >
                    <div class="btn-inner">
                      <div>Başlamaya hazır mısınız?</div>
                      <div class="btn-schedule-icon w-embed">
                        <FeatherIcon
                          icon={"arrow-right"}
                          width="20px"
                          height="20px"
                        />
                      </div>
                    </div>
                    <div class="btn-schedule-shape"></div>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="about-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="section-top-wrap">
                    <div className="section-top-tag">
                      <div>🏆 Lorem ipsum dolor sit amet!</div>
                    </div>
                  </div>
                  <div className="about-layout">
                    <div className="about-content">
                      <div className="about-title-wrap">
                        <h2 className="about-title">Dolor Sit Amet</h2>
                      </div>
                    </div>
                    <div className="about-box-wrap">
                      <div className="about-box">
                        <div className="about-box-number-wrap">
                          <h2 className="about-box-number">2Mn+</h2>
                        </div>
                        <div className="about-box-text-wrap">
                          <p className="about-box-text">Ürün Karşılaştırıldı</p>
                        </div>
                      </div>
                      <div className="about-box">
                        <div className="about-box-number-wrap">
                          <h2 className="about-box-number">2000K</h2>
                        </div>
                        <div className="about-box-text-wrap">
                          <p className="about-box-text">Kullanıcı</p>
                        </div>
                      </div>
                      <div className="about-box">
                        <div className="about-box-number-wrap">
                          <h2 className="about-box-number">900+</h2>
                        </div>
                        <div className="about-box-text-wrap">
                          <p className="about-box-text">Eklenti İndirmesi</p>
                        </div>
                      </div>
                      <div className="about-box last">
                        <div className="about-box-number-wrap">
                          <h2 className="about-box-number">10+</h2>
                        </div>
                        <div className="about-box-text-wrap">
                          <p className="about-box-text">Yardımcı Araç</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <NavLink
                    to="/signup"
                    className="btn-schedule-wrap w-inline-block yy gg ff"
                  >
                    <div class="btn-inner">
                      <div>Mutlu Kullanıcılarımızın Arasına Katılın!</div>
                      <div class="btn-schedule-icon w-embed">
                        <FeatherIcon
                          icon={"arrow-right"}
                          width="20px"
                          height="20px"
                        />
                      </div>
                    </div>
                    <div class="btn-schedule-shape"></div>
                  </NavLink>
                </div>
              </div>
            </div>
            <div className="cta-section">
              <div className="section-spacing">
                <div className="container">
                  <div className="cta-layout">
                    <div className="cta-left">
                      <div className="cta-title-wrap">
                        <h2 className="cta-title">
                          Amazon'da Uzmanlık Seviyenizi Yükseltin ve
                          Satışlarınızı Katlayın!
                        </h2>
                      </div>
                      <div className="cta-text-wrap">
                        <p className="cta-text">
                          Size zengin olmayı vadetmiyoruz! Amacımız; doğru
                          araçlar ve stratejilerle Amazon’da işlerinizi
                          hızlandırmak ve karar alma süreçlerinizi
                          kolaylaştırarak size uzun vadeli, gerçekçi ve
                          sürdürülebilir kazanç fırsatları sunmaktır.
                        </p>
                      </div>
                      <div className="cta-btn-wrap">
                        <NavLink
                          to="/signup"
                          className="btn-contact-wrap w-inline-block"
                        >
                          <div className="btn-inner-2">
                            <div>Hemen Başla, Denemeye Değer!</div>
                            <div className="btn-contact-icon-2 w-embed">
                              <FeatherIcon
                                icon={"arrow-right"}
                                width="20px"
                                height="20px"
                              />
                            </div>
                          </div>
                          <div className="btn-contact-shape-2"></div>
                        </NavLink>
                      </div>
                    </div>
                    <div className="cta-right">
                      <div className="cta-thumb-wrap">
                        <img
                          src="/assets/img/funnel-images/cta-thumb.png"
                          loading="lazy"
                          className="cta-thumb"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-section">
              <div className="footer-layout">
                <div className="nav-social-layout hide-mobile">
                  <a
                    href="https://www.facebook.com/kepicker.software/"
                    target="_blank"
                    className="nav-social-wrap w-inline-block"
                  >
                    <div className="nav-social-icon w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewbox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_776_8682)">
                          <path
                            d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <defs>
                          <clippath id="clip0_776_8682">
                            <rect
                              width="24"
                              height="24"
                              fill="currentColor"
                            ></rect>
                          </clippath>
                        </defs>
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://x.com/kepicker_"
                    target="_blank"
                    className="nav-social-wrap w-inline-block"
                  >
                    <div className="nav-social-icon w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewbox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.9455 23L10.396 15.0901L3.44886 23H0.509766L9.09209 13.2311L0.509766 1H8.05571L13.286 8.45502L19.8393 1H22.7784L14.5943 10.3165L23.4914 23H15.9455ZM19.2185 20.77H17.2398L4.71811 3.23H6.6971L11.7121 10.2532L12.5793 11.4719L19.2185 20.77Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://www.instagram.com/kepicker"
                    target="_blank"
                    className="nav-social-wrap w-inline-block"
                  >
                    <div className="nav-social-icon w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewbox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_776_8684)">
                          <path
                            d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8688 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8063 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8063 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M19.8469 5.59214C19.8469 6.38902 19.2 7.0312 18.4078 7.0312C17.6109 7.0312 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <defs>
                          <clippath id="clip0_776_8684">
                            <rect
                              width="24"
                              height="24"
                              fill="currentColor"
                            ></rect>
                          </clippath>
                        </defs>
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://www.youtube.com/@Kepicker"
                    target="_blank"
                    className="nav-social-wrap w-inline-block"
                  >
                    <div className="nav-social-icon w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewbox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.7609 7.20005C23.7609 7.20005 23.5266 5.54536 22.8047 4.8188C21.8906 3.86255 20.8688 3.85786 20.4 3.80161C17.0438 3.55786 12.0047 3.55786 12.0047 3.55786H11.9953C11.9953 3.55786 6.95625 3.55786 3.6 3.80161C3.13125 3.85786 2.10938 3.86255 1.19531 4.8188C0.473438 5.54536 0.24375 7.20005 0.24375 7.20005C0.24375 7.20005 0 9.14536 0 11.086V12.9047C0 14.8454 0.239062 16.7907 0.239062 16.7907C0.239062 16.7907 0.473437 18.4454 1.19062 19.1719C2.10469 20.1282 3.30469 20.0954 3.83906 20.1985C5.76094 20.3813 12 20.4375 12 20.4375C12 20.4375 17.0438 20.4282 20.4 20.1891C20.8688 20.1329 21.8906 20.1282 22.8047 19.1719C23.5266 18.4454 23.7609 16.7907 23.7609 16.7907C23.7609 16.7907 24 14.85 24 12.9047V11.086C24 9.14536 23.7609 7.20005 23.7609 7.20005ZM9.52031 15.1125V8.36724L16.0031 11.7516L9.52031 15.1125Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/kepicker/"
                    target="_blank"
                    className="nav-social-wrap w-inline-block"
                  >
                    <div className="nav-social-icon w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewbox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_776_8687)">
                          <path
                            d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5563 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2938 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516V20.4516Z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <defs>
                          <clippath id="clip0_776_8687">
                            <rect
                              width="24"
                              height="24"
                              fill="currentColor"
                            ></rect>
                          </clippath>
                        </defs>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <a href="https://kepicker.com" className="footer-link">
                www.kepicker.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FunnelTemplateTR01;
